import React, { FC, useState, useEffect } from "react";
import { Dialog, DialogContent, CircularProgress } from "@mui/material";
import classnames from "classnames";

import { useI18n } from "../../providers/I18n/I18n";
import { CheckCircleIcon } from "../../providers/RexIconsSVG/RexIconsSVG";
import { Button } from "../Wrappers/Wrappers";

import useStyles from "./styles";

interface IConfirmModal {
  show: boolean;
  onConfirmed: Function;
  onCancel: Function;
  bodyText?: string[];
  bodyElement?: JSX.Element;
  BodyComponent?: FC;
  bodyImage?: any;
  confirmedText: string;
  cancelText?: string;
  isLoading?: boolean;
  closeOnBackdrop?: boolean;
}

const MobileWidth = 500;

const ConfirmModal: FC<IConfirmModal> = ({
  show,
  onConfirmed,
  onCancel,
  bodyText,
  bodyElement = <></>,
  bodyImage = undefined,
  BodyComponent = undefined,
  confirmedText = "confirm",
  cancelText,
  isLoading = false,
  closeOnBackdrop = false,
}) => {
  const { t } = useI18n();
  const classes = useStyles();
  const [isMobile, setIsMobile] = useState(window.innerWidth < MobileWidth);

  useEffect(() => {
    setIsMobile(window.innerWidth < MobileWidth);
  }, [window.innerWidth]);

  const modalBodyText = () => {
    if (bodyText && bodyText.length) {
      return (
        <>
          <span data-testid="confirmModalText1">{t(bodyText[0])}</span>
          {bodyText.length && bodyText[1] ? (
            <span className={classes.boldText} data-testid="confirmModalText2">
              {t(bodyText[1])}?
            </span>
          ) : (
            ""
          )}
          {bodyElement}
        </>
      );
    } else if (BodyComponent) {
      return <BodyComponent />;
    }
    return t("confirmBodyText");
  };

  const handleOnCancel = () => {
    if (typeof onCancel === "function") {
      onCancel();
    }
  };

  return (
    <Dialog
      open={show}
      onClose={
        closeOnBackdrop
          ? (event, reason) => {
              if (reason !== "backdropClick") {
                handleOnCancel();
              }
            }
          : handleOnCancel
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classnames({ [classes.confirmDialog]: !isMobile })}
    >
      <div className={classnames({ [classes.confirmModalWrapper]: !isMobile })}>
        <DialogContent className={classes.dialogContent}>
          <div>{bodyImage || <CheckCircleIcon />}</div>
          {modalBodyText()}
          <div className={classes.actionButtons}>
            {isMobile && (
              <Button
                className={classnames(classes.button, classes.fullWidthButton)}
                testId="confirm_modal_submit_btn"
                onClick={() => !isLoading && onConfirmed()}
              >
                {isLoading ? <CircularProgress size={25} /> : t(confirmedText)}
              </Button>
            )}
            {cancelText && (
              <Button
                variant="outlined"
                className={classnames(classes.button, {
                  [classes.fullWidthButton]: isMobile,
                })}
                testId="confirm_modal_cancel_btn"
                onClick={handleOnCancel}
              >
                {t(cancelText)}
              </Button>
            )}
            {!isMobile && (
              <Button
                className={classes.button}
                testId="confirm_modal_submit_btn"
                onClick={() => !isLoading && onConfirmed()}
              >
                {isLoading ? <CircularProgress size={25} /> : t(confirmedText)}
              </Button>
            )}
          </div>
        </DialogContent>
      </div>
    </Dialog>
  );
};

export default ConfirmModal;
